<template>
      <v-sheet class="home">
        <v-sheet class="pb-5">
          <div class="position-relative widget">
          <pull-to class="white elevation-10 border-radius-bawah" :top-config="TOP_DEFAULT_CONFIG" :top-load-method="refresh">
            <div class="pt-5 pb-3 text-center">
              <filter-widget button-color="dark" />
              <div class="fade-in">
                <h6>Pull to refresh</h6>
                <v-icon>mdi-chevron-down</v-icon>
              </div>
            </div>
          </pull-to>
          </div>
          <div class="position-relative pt-5">
            <v-container>
              <card-lists :receipts="receipts"/>
            </v-container>
          </div>
        </v-sheet>
      </v-sheet>
</template>

<script>
import PullTo from 'vue-pull-to'
import FilterWidget from './component/FilterWidget.vue'
import {mapGetters , mapActions} from 'vuex'
import CardLists from './component/CardLists.vue'
export default {
  name: 'Home',
  components: {
    FilterWidget,
    CardLists,
    PullTo
  },
  data () {
    return {
      TOP_DEFAULT_CONFIG : {
        pullText: 'Pull to Refresh', // The text is displayed when you pull down
        triggerText: 'Fetching', // The text that appears when the trigger distance is pulled down
        loadingText: 'Loading...', // The text in the load
        doneText: 'Done', // Load the finished text
        failText: 'Failed', // Load failed text
        loadedStayTime: 400, // Time to stay after loading ms
        stayDistance: 70, // Trigger the distance after the refresh
        triggerDistance:30 // Pull down the trigger to trigger the distance
      }
    }
  },
  computed : {
    ...mapGetters({
      'user' : 'Auth/user',
      'receipts' : 'Forms/receipts'
    })
  },
  mounted () {
    console.log(this.user)
    if (!localStorage.getItem("user")) {
      this.$router.push({
        name: "Login",
      })
    }
    this.getReceipts({id : this.user.id})
  },
  methods : {
    ...mapActions({
      getUser : 'Auth/getUser',
      getReceipts : 'Forms/getReceipts'
    }),
    async refresh(loaded) {
      await this.getReceipts({id : this.user.id})
      loaded('done')
    },
    getPendingReceipts () {
      let count = 0
      for (let index = 0; index < this.receipts.length; index++) {
        if(this.receipts[index].status == 0){
          count++
        }  
      }
      return count;
    }
  }
}
</script>

<style scoped>
.home {
  background : #fff;
}
.pending-badge {
  color : white;
  border-radius: 50%;
  background : salmon;
  display : flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  width: 25px;
  height: 25px;
}
.widget {
  z-index: 2;
}
.border-radius-bawah {
  border-radius : 0px 0px 20px 20px
}
</style>
